import React from "react";

import * as yup from "yup";

import ActionDropdown from "components/Common/ActionDropdown";
import { ColumnStyle, LinkText } from "components/Common/TableStyle";

export const VALUE_COLUMNS = (handleEdit, handleDelete, userPermissions) => [
  {
    title: "Value",
    key: "name",
    dataIndex: "name",
    width: 150,
    render: text => <LinkText text={text} />,
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: 200,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    title: "Start Date",
    key: "start_date",
    dataIndex: "start_date",
    width: 125,
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "End Date",
    key: "end_date",
    dataIndex: "end_date",
    width: 125,
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "action",
    width: 100,
    align: "center",
    render: (_, record) => (
      <ActionDropdown
        editProps={{
          onClick: () => handleEdit(record),
        }}
        deleteProps={{
          onClick: () => handleDelete(record),
        }}
        userPermissions={userPermissions}
      />
    ),
  },
];

export const CREATE_VALUE_INITIAL_VALUES = {
  name: "",
  description: "",
  startDate: "",
  endDate: "",
};

export const CREATE_VALUE_VALIDATION_SCHEMA = yup.object({
  name: yup.string().trim().required("Name is required."),
  description: yup.string().trim(),
  startDate: yup.date(),
  endDate: yup
    .date()
    .min(yup.ref("startDate"), "End date should be more than start date"),
});
